import { useEffect, useRef, useState } from "react";
import { ChevronDown, ChevronRight, LogOut, Settings, ShieldAlert, UserRound } from "lucide-react";
import { NavLink } from "react-router-dom";

export function MyPageMenu({ session, logout, settingsNavigation }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const menuRef = useRef(null);
  const visibleSettings = settingsNavigation.filter((item) => !item.permission || session.user.permissions.includes(item.permission));

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsSettingsOpen(false);
  };

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === "Escape") closeMenu();
    };
    const closeOnOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) closeMenu();
    };
    document.addEventListener("keydown", closeOnEscape);
    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => {
      document.removeEventListener("keydown", closeOnEscape);
      document.removeEventListener("mousedown", closeOnOutsideClick);
    };
  }, []);

  return (
    <div className="user-menu" ref={menuRef} data-testid="user-menu">
      <button className={`nav-link user-menu-trigger ${isMenuOpen ? "active" : ""}`} onClick={() => { setIsMenuOpen(!isMenuOpen); setIsSettingsOpen(false); }} data-testid="my-page-menu-trigger" aria-expanded={isMenuOpen}>
        <UserRound size={19} weight="bold" />
        La mia pagina
        <ChevronDown size={15} className={isMenuOpen ? "chevron-open" : ""} />
      </button>
      {isMenuOpen && <div className="user-dropdown" data-testid="user-menu-dropdown">
        <div className="user-dropdown-header"><b>{session.user.name}</b><span>{session.company.name}</span></div>
        <button className="user-dropdown-link settings-submenu-trigger" onClick={() => setIsSettingsOpen(!isSettingsOpen)} data-testid="my-page-settings-trigger" aria-expanded={isSettingsOpen}>
          <Settings size={17} /> Impostazioni <ChevronRight size={15} className={isSettingsOpen ? "settings-chevron-open" : ""} />
        </button>
        {isSettingsOpen && <div className="settings-submenu" data-testid="my-page-settings-submenu">
          {visibleSettings.map(({ to, label, icon: Icon }) => <NavLink key={to} to={to} className="user-dropdown-link settings-submenu-link" onClick={closeMenu} data-testid={`my-page-${to.slice(1)}`}><Icon size={16} /> {label}</NavLink>)}
        </div>}
        {session.user.is_platform_admin && (
          <NavLink to="/super-admin" className="user-dropdown-link" onClick={closeMenu} data-testid="my-page-super-admin">
            <ShieldAlert size={17} /> Gestione piattaforma
          </NavLink>
        )}
        <button className="user-dropdown-link signout-link" onClick={logout} data-testid="my-page-logout"><LogOut size={17} /> Esci</button>
      </div>}
      <div className="account-card" data-testid="current-user-summary"><b>{session.user.name}</b><span>{session.company.name}</span></div>
    </div>
  );
}
